import { Field, ErrorMessage, FieldArray } from "formik";
import TextError from "../../../forms/TextError";
import SelectMultipleWithSearch from "../../Admin/Common/SelectMultipleWithSearch";
import { memo ,useEffect ,useState } from "react";
import { handleKeyPress } from "../../../functions/Utils";
import {
  ORIGIN_DESTINATION_CHARGE_TYPE,
  VAS_RATE_CHARGE_TYPE,
} from "../../../utils/constant";
import { useDispatch, useSelector } from 'react-redux';
import { getIncoTerms } from "../../../store/Admin/RateManagement/RateManagementSlice";
import SelectItem from "../Common/SelectItem";
import { Copy, Plus, Trash2 } from "lucide-react";
// import {IncoTerms1} from '../../../utils/dropdownValues'
const AirVasRateForm = memo(({ formikData, type, formData, vasdata }) => {
  const { values } = formikData;
  const dispatch = useDispatch();
  const [Incoterms, setIncoterms] = useState([]);
  const { airport, currency, chargeList } = formData;

  console.log(Incoterms, "Incoterms");
  useEffect(() => {
    dispatch(getIncoTerms())
      .then((res) => {
        if (res.type === 'rateManagement/getIncoTerms/fulfilled') {
          console.log('Fetched IncoTerms:', res.payload);
          setIncoterms(res.payload);
        }
      })
      .catch((err) => {
        console.error('Error fetching IncoTerms:', err);
      });
            
console.log(vasdata,"vasdata");
  }, []);
  const allOption = Incoterms.find(opt => opt.type === 'alltype');
  const noneOption = Incoterms.find(opt => opt.type === 'none');
  
  const exportOptions =Incoterms
    .filter(item => item.type === "export")
    .map(item => ({
      label: item.incoterms,
      value: item.incoterms,
    }));
  
  const importOptions = Incoterms
    .filter(item => item.type === "import")
    .map(item => ({
      label: item.incoterms,
      value: item.incoterms,
    }));


  const incotermOptions = [
    {
      label: allOption?.incoterms?.toUpperCase() || "ALL",
      value: allOption?.incoterms || "all",
    },
    {
      label: noneOption?.incoterms?.toUpperCase() || "NONE",
      value: noneOption?.incoterms || "none",
    },
    { 
      label: <strong>EXPORT</strong>, 
      value: "EXPORT_LABEL", 
      disabled: true,
      isLabel: true,
      style: { fontWeight: 'bold', color: '#333' }
    },
    ...exportOptions,
    { 
      label: <strong>IMPORT</strong>, 
      value: "IMPORT_LABEL", 
      disabled: true,
      isLabel: true,
      style: { fontWeight: 'bold', color: '#333' }
    },
    ...importOptions,
  ];
  


  // const SERVICE_TYPES = [
  //   { label: "All", value: "ALL" },
  //   { label: "None", value: "NONE" },
  //   { label: "Service A", value: "A" },
  //   { label: "Service B", value: "B" },
  //   { label: "Service C", value: "C" },
  // ];

  return (
    <>
      <div className="2xl:flex  xl:flex  lg:flex  block justify-between items-center mt-5 mb-2 bg-gray-50 py-1 px-2 rounded-md ">
        <div className="font-bold text-lg flex">
          <img
            src="https://staging.sgate.in/html/designer/skart/freight.png"
            className="w-[29px]"
          />

          <p className=" border-solid  border-l pl-3 ml-3">VAS Rate</p>
        </div>
      </div>

      <div className="w-full mt-5 mb-5">
        <label
          htmlFor={`airport`}
          className="py-0 inline-block text-lg font-semibold leading-5 text-[#3F3F3F]"
        >
          Airport
        </label>
        <div className="airportwidthh inline-block 2xl:w-[430px] xl:w-[430px] lg:w-[330px]  md:w-full  sm:w-full  2xl:ml-2 xl:ml-2 lg:ml-2 md:ml-0  sm:ml-0  md:mt-2">
          {type === "create" ? (
            <>
              <Field
                as={SelectMultipleWithSearch}
                options={airport}
                mode="multiple"
                width={"100%"}
                id={`airport`}
                name={`airport`}
                className=" "
                handleChange={formikData.handleChange}
                setFieldValue={formikData.setFieldValue}
              />
              <ErrorMessage name={`airport`} component={TextError} />
            </>
          ) : (
            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
              {vasdata?.airport?.cityName}
            </div>
          )}
        </div>{" "}
      </div>

      <FieldArray name="vasRate_charge">
        {({ remove, push }) => (
          <div>
            <div className="grid grid-cols-12 2xl:gap-4 xl:gap-4  lg:gap-4 gap-2 ">
              {type === "create" && (
                <div className="col-span-12 2xl:col-span-1 xl:col-span-1  lg:col-span-1  2xl:order-last xl:order-last  lg:order-last order-first">
                  <div className="2xl:mt-[28px] xl:mt-[28px] lg:mt-[28px] mt-[2px] originbuttonn relative">
                    <button
                      type="button"
                      onClick={() =>
                        push({
                          type: "",
                          chargeHead: "",
                          currency: "",
                          exchange_rate: "",
                          rate: "",
                          unit: "",
                        })
                      }
                      title="Add New Item"
                      className="float-right w-15 h-10 p-[5px] flex justify-center items-center"
                    >
                      <Plus className="float-right text-white bg-yellow-500 hover:bg-gray-700 rounded-lg w-[35px] h-[35px] p-[1px] text-lg" />
                    </button>
                  </div>
                </div>
              )}

              {/* <div className="2xl:col-span-4 xl:col-span-4  lg:col-span-4 md:col-span-12  sm:col-span-12 DepartureDaysbox "> */}

              <div className="col-span-12 2xl:col-span-11 xl:col-span-11 lg:col-span-11">
                {values.vasRate_charge?.map((vas_rate, index) => (
                  <>
                    <div className="originplusMain my-3 justify-between 2xl:block xl:block lg:block sm:grid sm:grid-cols-2 md:grid md:grid-cols-3   2xl:gap-4 xl:gap-4 lg:gap-4 gap-2">
                      {" "}
                      <div className="originplusAir inline-block 2xl:w-[16%] xl:w-[16%] lg:w-[16%] md:w-full  sm::w-full   ">
                        <label
                          htmlFor={`vasRate_charge.${index}.type`}
                          className="py-0 block text-xs font-semibold leading-5 text-[#3F3F3F]"
                        >
                          Type
                        </label>
                        {type === "create" ? (
                          <>
                            <Field
                              as={SelectItem}
                              options={ORIGIN_DESTINATION_CHARGE_TYPE}
                              width={"100%"}
                              id={`vasRate_charge.${index}.type`}
                              name={`vasRate_charge.${index}.type`}
                              className="leading-6 h-[20px] px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                              handleChange={formikData.handleChange}
                              setFieldValue={formikData.setFieldValue}
                            />
                            <ErrorMessage
                              name={`vasRate_charge[${index}].type`}
                              component={TextError}
                            />
                          </>
                        ) : (
                          <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                            {vasdata?.type}
                          </div>
                        )}

                        <small className="text-xs">Origin / Destination</small>
                      </div>
                      <div className="originplusAir inline-block 2xl:w-[15%] xl:w-[15%] lg:w-[15%] md:w-full  sm::w-full   ">
                        <label
                          htmlFor={`vasRate_charge.${index}.chargeHead`}
                          className="py-0 block text-xs font-semibold leading-5 text-[#3F3F3F]"
                        >
                          Charge Head
                        </label>
                        <>
                          {type === "create" ? (
                            <>
                              <Field
                                as={SelectMultipleWithSearch}
                                options={chargeList}
                                width={"100%"}
                                id={`vasRate_charge.${index}.chargeHead`}
                                name={`vasRate_charge.${index}.chargeHead`}
                                className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                                handleChange={formikData.handleChange}
                                setFieldValue={formikData.setFieldValue}
                              />
                              <ErrorMessage
                                name={`vasRate_charge.${index}.chargeHead`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {vasdata?.chargeHead?.charge_name}
                            </div>
                          )}
                        </>
                      </div>
                      <div className="originplusAir inline-block 2xl:w-[12%] xl:w-[12%] lg:w-[12%] md:w-full  sm::w-full   ">
                        <label
                          htmlFor={`vasRate_charge.${index}.currency`}
                          className="py-0 block text-xs font-semibold leading-5 text-[#3F3F3F]"
                        >
                          Currency
                        </label>
                        <>
                          {type === "edit" || type === "create" ? (
                            <>
                              <Field
                                as={SelectMultipleWithSearch}
                                options={currency}
                                width={"100%"}
                                id={`vasRate_charge.${index}.currency`}
                                name={`vasRate_charge.${index}.currency`}
                                className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                                handleChange={formikData.handleChange}
                                setFieldValue={formikData.setFieldValue}
                                handlePopulateData={(id) => {
                                  const inrRate = currency?.find(
                                    (item) => item?._id === id
                                  );
                                  formikData.setFieldValue(
                                    `vasRate_charge.${index}.exchange_rate`,
                                    inrRate?.inrRate
                                  );
                                }}
                              />
                              <ErrorMessage
                                name={`vasRate_charge.${index}.currency`}
                                component={TextError}
                              />
                            </>
                          ) : (
                            <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                              {vasdata?.currency?.currency}
                            </div>
                          )}
                        </>
                      </div>
                      <div className="originplusAir inline-block 2xl:w-[15%] xl:w-[15%] lg:w-[15%] md:w-full  sm::w-full    ">
                        <label
                          htmlFor={`vasRate_charge.${index}.exchange_rate`}
                          className="py-0 block text-xs font-semibold leading-5 text-[#3F3F3F]"
                        >
                          Exchange rate INR
                        </label>
                        {type === "edit" || type === "create" ? (
                          <>
                            <Field
                              type="text"
                              id={`vasRate_charge.${index}.exchange_rate`}
                              name={`vasRate_charge.${index}.exchange_rate`}
                              className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                              onChange={formikData.handleChange}
                              onKeyPress={handleKeyPress}
                            />
                            <ErrorMessage
                              name={`vasRate_charge.${index}.exchange_rate`}
                              component={TextError}
                            />
                          </>
                        ) : (
                          <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                            {vasdata?.exchange_rate}
                          </div>
                        )}
                      </div>
                      <div className="originplusAir inline-block 2xl:w-[10%] xl:w-[10%] lg:w-[10%] md:w-full  sm::w-full    ">
                        <label
                          htmlFor={`vasRate_charge.${index}.rate`}
                          className="py-0 block text-xs font-semibold leading-5 text-[#3F3F3F]"
                        >
                          Rate
                        </label>
                        {type === "edit" || type === "create" ? (
                          <>
                            <Field
                              type="text"
                              id={`vasRate_charge.${index}.rate`}
                              name={`vasRate_charge.${index}.rate`}
                              className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                              onChange={formikData.handleChange}
                              onKeyPress={handleKeyPress}
                            />
                            <ErrorMessage
                              name={`vasRate_charge.${index}.rate`}
                              component={TextError}
                            />
                          </>
                        ) : (
                          <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                            {vasdata?.rate}
                          </div>
                        )}
                      </div>
                      <div className="originplusAir inline-block 2xl:w-[12%] xl:w-[12%] lg:w-[12%] md:w-full  sm::w-full   ">
                        <label
                          htmlFor={`vasRate_charge.${index}.unit`}
                          className="py-0 block text-xs font-semibold leading-5 text-[#3F3F3F]"
                        >
                          Unit
                        </label>
                        {type === "edit" || type === "create" ? (
                          <>
                            <Field
                              as={SelectItem}
                              options={VAS_RATE_CHARGE_TYPE}
                              width={"100%"}
                              id={`vasRate_charge.${index}.unit`}
                              name={`vasRate_charge.${index}.unit`}
                              className="leading-6  px-2 py-2 focus:border focus:outline-0 block w-full text-sm font-normal border rounded-md text-[#757575]"
                              handleChange={formikData.handleChange}
                              setFieldValue={formikData.setFieldValue}
                            />
                            <ErrorMessage
                              name={`vasRate_charge.${index}.unit`}
                              component={TextError}
                            />
                          </>
                        ) : (
                          <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                            {vasdata?.unit}
                          </div>
                        )}
                      </div>
                      <div className="w-full mt-5 inline-block mb-5">
                        <label
                          htmlFor={`incoterms`}

                          className="py-0 inline-block text-sm font-semibold leading-5 text-[#3F3F3F]"
                        >
                          Service Types
                        </label>

                        <div className="airportwidthh inline-block 2xl:w-[430px] xl:w-[430px] lg:w-[330px] md:w-[220px] sm:w-full 2xl:ml-2 xl:ml-2 lg:ml-2 md:ml-0 sm:ml-0 md:mt-2">
                     {type === "edit" || type === "create" ? (
                          <><Field
  as={SelectMultipleWithSearch}
  options={incotermOptions}
  mode="multiple"
  id={`incoterms`}
  name={`incoterms`}
  width="70%"
  value={vasdata?.incoterms?.map((item) => item)}
  handleChange={(selected) => {
    let newSelected = selected;
    
    // Filter out any label values that might have been selected
    newSelected = newSelected.filter(
      v => v !== "EXPORT_LABEL" && v !== "IMPORT_LABEL"
    );

    if (selected.includes("all")) {
      // Get all selectable values (excluding labels)
      const allValues = [
        "all",
        "none",
        ...exportOptions.map(opt => opt.value),
        ...importOptions.map(opt => opt.value),
      ];
      newSelected = allValues;
    } else if (selected.includes("none")) {
      const allValues = [
        "all",
        "none",
        ...exportOptions.map(opt => opt.value),
        ...importOptions.map(opt => opt.value),
      ];
      newSelected = allValues;
      // newSelected = ["none"];
    } else {
      // Remove "all" and "none" if other options are selected
      newSelected = newSelected.filter(v => v !== "all" && v !== "none");
    }

    // formikData.setFieldValue("incoterms", newSelected);
    formikData.setFieldValue(`incoterms`, newSelected);
   
    
  }}
  
  setFieldValue={formikData.setFieldValue}
  isOptionDisabled={(option) => option.disabled}

/></>
                        ) : (
                          <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                            {vasdata?.incoterms.map((item) => item).join(", ")}
                          </div>
                        )}


                          <ErrorMessage
                            name="incoterms"
                            component={TextError}
                          />
                        </div>
                      </div>
                      {/* <div className="w-full mb-5">
  <label
                          htmlFor={`vasRate_charge.${index}.incoterms`}
    
    className="py-0 inline-block text-lg font-semibold leading-5 text-[#3F3F3F]"
  >
    Service Types
  </label>
  <div className="inline-block 2xl:w-[430px] xl:w-[430px] lg:w-[330px] md:w-full sm:w-full 2xl:ml-2 xl:ml-2 lg:ml-2 md:ml-0 sm:ml-0 md:mt-2">
    {type === "edit" || type === "create" ? (
      <>
        <Field
          as={SelectMultipleWithSearch}
          options={incotermOptions}
          id={`vasRate_charge.${index}.incoterms`}
          name={`vasRate_charge.${index}.incoterms`}
          className=""
          handleChange={formikData.handleChange}
          setFieldValue={formikData.setFieldValue}
        />
        <ErrorMessage name="serviceTypes" component={TextError} />
      </>
    ) : (
      <div className="p-2 border rounded-md text-sm text-[#757575] bg-gray-100">
                {Array.isArray(vasdata?.incoterm)
          ? vasdata.incoterm.join(", ")
          : vasdata?.incoterm || "—"}

      </div>
    )}
  </div>
</div> */}

                      <div className="originplusAir inline-block 2xl:w-[12%] xl:w-[12%] lg:w-[12%] md:w-full  sm::w-full    ">
                        <div className="originplus flex w-[120px] justify-start 2xl:mt-[19px]  xl:mt-[19px] lg:mt-[19px] mt-[0] text-red-500 flex self-start">
                          {type === "create" && (
                            <>
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  push({
                                    type: vas_rate?.type,
                                    chargeHead: vas_rate?.chargeHead,
                                    currency: vas_rate?.currency,
                                    exchange_rate: vas_rate?.exchange_rate,
                                    rate: vas_rate?.rate,
                                    unit: vas_rate?.unit,
                                  });
                                }}
                              >
                                <Copy className=" bg-gray-200 hover:bg-yellow-500 hover:text-white  text-sm text-gray-600 rounded-lg w-[40px] h-[36px] p-2 mt-0 " />
                              </button>

                              {index > 0 && (
                                <>
                                  <button
                                    type="button"
                                    onClick={() => remove(index)}
                                    title="Delete Item"
                                    className="w-10 h-10 flex justify-center items-center"
                                  >
                                    <Trash2 className="bg-red-200 hover:bg-yellow-500 hover:text-white  text-sm text-red-700 rounded-lg w-[40px] h-[36px] p-2 ml-[4px] " />
                                  </button>
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
        )}
      </FieldArray>
      {values.errorMessage != "" && (
        <div className="className='error text-red-500 mt-2 text-sm font-normal leading-5">
          {values.errorMessage}
        </div>
      )}
    </>
  );
});

export default AirVasRateForm;
